<template>
  <a-spin :spinning="loading">
    <a-row>
      <a-col :span="8">
        <a-descriptions
          :column="1"
          class="iotplt-descriptions"
        >
          <a-descriptions-item label="EID">
            {{ detail.eid || '-' }}
          </a-descriptions-item>
          <a-descriptions-item label="产品名称">
            {{ detail.product_name || '-' }}
          </a-descriptions-item>
          <a-descriptions-item label="SGP规范">
            {{ detail.sgp_spec_names || '-' }}
          </a-descriptions-item>
          <a-descriptions-item label="eIM平台">
            {{ detail.eim_platform_name || '-' }}
          </a-descriptions-item>
        </a-descriptions>
      </a-col>

      <a-col :span="8">
        <a-descriptions
          :column="1"
          class="iotplt-descriptions iotplt-descriptions-max-8"
        >
          <a-descriptions-item label="eIM注册状态">
            {{ detail.eim_register_status_name || '-' }}
          </a-descriptions-item>
          <a-descriptions-item label="通信协议">
            {{ detail.eim_support_protocol_name || '-' }}
          </a-descriptions-item>
          <a-descriptions-item label="请求间隔(秒)">
            {{ detail.eim_request_interval || '-' }}
          </a-descriptions-item>
          <a-descriptions-item label="卡片材质">
            {{ detail.card_type_name || '-' }}
          </a-descriptions-item>
        </a-descriptions>
      </a-col>

      <a-col :span="8">
        <a-descriptions
          :column="1"
          class="iotplt-descriptions"
        >
          <a-descriptions-item label="卡片尺寸">
            {{ detail.card_shape_name || '-' }}
          </a-descriptions-item>
          <a-descriptions-item label="订单编号">
            {{ detail.order_no || '-' }}
          </a-descriptions-item>
          <a-descriptions-item label="划拨时间">
            {{ detail.allocated_at || '-' }}
          </a-descriptions-item>
        </a-descriptions>
      </a-col>
    </a-row>
  </a-spin>
</template>

<script>
import { findEsimDetail } from '@/api/esim'

export default {
  name: 'ShowEsimBaseInfo',
  props: {
    id: { type: Number, required: true }
  },
  data() {
    return {
      loading: false,
      detail: {}
    }
  },
  created() {
    this.fetchDetail()
  },
  methods: {
    fetchDetail() {
      this.loading = true
      findEsimDetail(this.id).then((res) => {
        if (res.code === 0) {
          this.detail = res.data || {}
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
